import { render, staticRenderFns } from "./PerfumeAndSimilars.vue?vue&type=template&id=32dde3a7&scoped=true"
import script from "./PerfumeAndSimilars.vue?vue&type=script&lang=js"
export * from "./PerfumeAndSimilars.vue?vue&type=script&lang=js"
import style0 from "./PerfumeAndSimilars.vue?vue&type=style&index=0&id=32dde3a7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dde3a7",
  null
  
)

export default component.exports